module.exports = __webpack_public_path__ + "img/artboard20.748d97dc.png";